// repeat, pad, formatTime are stolen from redux-logger ;-)

/**
 * Repeat a str n times
 * @param str the string to be repeated
 * @param time how many time it should be repeated
 * @return the repeated string
 */
function repeat(str, times) {
    return new Array(times + 1).join(str)
}

/**
 * Formats a number with padding
 * @param num the number to be formatted
 * @param maxLength the maximum formatted string length
 * @return the number formatted as string
 */
function pad(num, maxLength) {
    return repeat('0', maxLength - num.toString().length) + num
}

/**
 * Formats a time value
 * @param {Date} time the time value to be formatted
 * @return {string} the time value formatted as string
 */
function formatTime(time) {
    const hour = pad(time.getHours(), 2)
    const minute = pad(time.getMinutes(), 2)
    const seconds = pad(time.getSeconds(), 2)
    const ms = pad(time.getMilliseconds(), 3)

    return `${hour}:${minute}:${seconds}.${ms}`
}

export function createLogger(_console = console) {
    if (!_console) {
        throw new Error('No target for logging provided!')
    }

    return {
        /**
         * Log to console
         */
        log() {
            _console.log(...buildParams(...arguments))
        },

        /**
         * Log at debug level to console
         */
        debug() {
            _console.debug(...buildParams(...arguments))
        },

        /**
         * Log at info level to console
         */
        info() {
            _console.info(...buildParams(...arguments))
        },

        /**
         * Log at warn level to console
         */
        warn() {
            _console.warn(...buildParams(...arguments))
        },

        /**
         * Log at error level to console
         */
        error() {
            _console.error(...buildParams(...arguments))
        }
    }

    /**
     * Puts formatted time in front of the log output
     * @return an array with all the log arguments to be provided to appropriate console logging method
     */
    function buildParams() {
        const time = new Date()
        return [formatTime(time), ':', ...arguments]
    }
}

const defaultLogger = createLogger()

export default defaultLogger
